import { Permissions, security } from "Common/permissions";
import filter from "lodash/filter";
import map from "lodash/map";
import { connect } from "react-redux";
import Connections from "./connections";
import actionCreators from "./redux/actionCreators";
import { getConnectionsDataMap, getConnectionsDictionaryMap, getExpandedPermissions, getInProgress, getSettingsDataMap, getSettingsDictionaryMap } from "./redux/selectors";
const canEdit = security.isAllowed([Permissions.SettingsEdit]);
const mapStateToProps = (state) => ({
    typesConnection: getConnectionsDictionaryMap(state),
    listConnections: getConnectionsDataMap(state),
    listSettings: getSettingsDataMap(state),
    typesSetting: getSettingsDictionaryMap(state),
    inProgress: getInProgress(state),
    canEdit,
    expandedPermissions: getExpandedPermissions(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => {
        dispatch(actionCreators.getSettingsTypeDictionary());
        dispatch(actionCreators.getSettings());
    },
    onTest: (connection) => {
        dispatch(actionCreators.testConnection(connection));
    },
    onReloadOntology: () => {
        dispatch(actionCreators.reloadOntology());
    },
    onSave: (listConnections, listSettings) => {
        Promise.all([
            ...map(filter(listConnections, "Changed"), connection => dispatch(actionCreators.saveConnection(connection))),
            ...map(filter(listSettings, "Changed"), setting => dispatch(actionCreators.saveSetting(setting)))
        ]).then(() => {
            dispatch(actionCreators.getSettings());
        });
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(Connections);
